import React, { Fragment } from "react";
import { StaticQuery, graphql } from "gatsby";
import url from "url";
import { addHours } from "date-fns";

import Events from "src/components/Modules/Events/Events";
const ArtistHighlightEvents = ({
  data,
  artist,
  label,
  readMoreText,
  setHaveEvents,
}) => {
  const today = Date.now();
  const upcomingArtistEvents =
    data?.allWpEvent?.edges?.length > 0
      ? data.allWpEvent.edges
          .map(({ node: event }) => event)
          .filter((event) => {
            return addHours(new Date(event.acfEventPage.date), 22) >= today;
          })
          .filter((event) => {
            return event.acfEventPage.artist.databaseId === artist.databaseId;
          })
      : [];

  const highlightedEvents =
    upcomingArtistEvents?.length > 0 ? upcomingArtistEvents.slice(0, 5) : [];
  if (setHaveEvents && highlightedEvents?.length < 1) {
    setHaveEvents(false);
  }
  return (
    <Fragment>
      {highlightedEvents?.length > 0 && (
        <Events
          events={highlightedEvents}
          label={label}
          size="small"
          readMore={
            upcomingArtistEvents.length > highlightedEvents.length && {
              text: readMoreText,
              url: artist?.link
                ? url.parse(artist.link).pathname + "konserter"
                : "",
            }
          }
        />
      )}
    </Fragment>
  );
};

export default (props) => (
  <StaticQuery
    query={graphql`
      query {
        allWpEvent(sort: { fields: [acfEventPage___date], order: ASC }) {
          edges {
            node {
              title
              acfEventPage {
                artist {
                  ... on WpArtist {
                    title
                    databaseId
                  }
                }
                date
                location {
                  venue
                  city
                  country
                }
                ticket {
                  status
                  releaseDate
                  link
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => <ArtistHighlightEvents data={data} {...props} />}
  />
);

// TODO: Add prop types
